import ThumbnailComponent from '72cms-ui/components/table-elements/ThumbnailComponent';
import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        image: {
            component: ThumbnailComponent,
            variant: 'w50',
        },
        name: {
            component: LinkTitleComponent,
        },
        type: {},
    },
    sortable: [],
    filterable: ['type'],
    toolbar: ['create'],
    pagination: true,
    searchable: true,
    treeView: false,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.page-panels.js